import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Stack,
  Box,
  Card,
  Chip,
  Divider,
  Grid,
  Tooltip,
} from "@mui/material";
import {
  Close,
  LocationOn,
  AccessTime,
  History,
  Login,
  Logout,
  WorkHistory,
} from "@mui/icons-material";
import pdfImage from "../Components/Assets/images/pdf.jfif";
import { Avatar } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import excelImage from "../Components/Assets/images/excel.png";
import DownloadAttendanceFullPdf from "../Components/Download/DownloadAttendanceFullPdf";
import DownloadAttendanceFullExcel from "../Components/Download/DownloadAttendanceFullExcel";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
const AttendanceDetailDialog = ({
  open,
  onClose,
  detailData,
  employeeName,
  companyName,
  companyLogo,
  setOpenBackdrop,
}) => {
  if (!detailData) return null;

  const handleDownloadPdf = () => {
    DownloadAttendanceFullPdf(
      detailData,
      companyName,
      companyLogo,
      setOpenBackdrop,
      employeeName,
    );
  };

  const handleDownloadExcel = () => {
    DownloadAttendanceFullExcel(
      detailData,
      companyName,
      setOpenBackdrop,
      employeeName,
    );
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3, p: 1 } }}
    >
      {/* Header */}
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1}>
          <History color="primary" />
          <Typography variant="h6" fontWeight="bold">
            Punch Logs
          </Typography>
          <Grid
            item
            xs={3}
            md={5}
            sx={{
              display: "flex",
              justifyContent: { xs: "flex-start", md: "flex-end" },
              gap: 1,
            }}
          >
            <Tooltip title="Download PDF">
              <IconButton onClick={handleDownloadPdf}>
                <img
                  src={pdfImage}
                  alt="pdf"
                  style={{ width: 28, height: 28 }}
                />
              </IconButton>
            </Tooltip>

            <Tooltip title="Download Excel">
              <IconButton onClick={handleDownloadExcel}>
                <img
                  src={excelImage}
                  alt="excel"
                  style={{ width: 28, height: 28 }}
                />
              </IconButton>
            </Tooltip>
          </Grid>
        </Stack>
        <IconButton onClick={onClose} size="small">
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ bgcolor: "#f8f9fa" }}>
        {/* Summary Section */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={6}>
            <Card
              sx={{
                p: 2,
                textAlign: "center",
                boxShadow: "none",
                border: "1px solid #e0e0e0",
              }}
            >
              <Typography variant="caption" color="text.secondary">
                PUNCH DATE
              </Typography>
              <Typography variant="body1" fontWeight="bold">
                {detailData.punch_date}
              </Typography>
            </Card>
          </Grid>
          <Grid item xs={6}>
            <Card
              sx={{
                p: 2,
                textAlign: "center",
                bgcolor: "#e3f2fd",
                boxShadow: "none",
                border: "1px solid #bbdefb",
              }}
            >
              <Typography variant="caption" color="primary">
                TOTAL HOURS
              </Typography>
              <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={0.5}
              >
                <WorkHistory sx={{ fontSize: 16 }} color="primary" />
                <Typography variant="body1" fontWeight="bold" color="primary">
                  {detailData.total_working_hours}
                </Typography>
              </Stack>
            </Card>
          </Grid>
        </Grid>

        <Typography
          variant="subtitle2"
          sx={{ mb: 2, color: "text.secondary", fontWeight: "bold" }}
        >
          DETAILED TIMELINE
        </Typography>

        {/* Timeline Cards */}
        <Stack spacing={2}>
          {detailData.punches.map((punch, index) => (
            <Card
              key={punch.id}
              sx={{
                p: 2,
                borderRadius: 2,
                position: "relative",
                borderLeft: `5px solid ${punch.type === "IN" ? "#4caf50" : "#f44336"}`,
              }}
            >
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Stack direction="row" spacing={1} alignItems="center">
                  {punch.type === "IN" ? (
                    <Login color="success" />
                  ) : (
                    <Logout color="error" />
                  )}
                  <Chip
                    label={punch.type}
                    size="small"
                    color={punch.type === "IN" ? "success" : "error"}
                    sx={{ fontWeight: "bold", width: 50 }}
                  />
                  <Typography variant="body2" fontWeight="600">
                    {punch.punch_time.split(" ")[1]}
                  </Typography>
                </Stack>
                {/* <Typography
                  variant="caption"
                  sx={{ bgcolor: "#eee", px: 1, borderRadius: 1 }}
                >
                  ID: #{punch.id}
                </Typography> */}
              </Stack>

              <Divider sx={{ my: 1.5 }} />

              <Stack
                direction="row"
                spacing={2}
                alignItems="center"
              >
                <Zoom>


                  <Avatar
                    src={punch.punch_image || ""}
                    alt="Punch Image"
                    sx={{
                      width: 55,
                      height: 55,
                      border: "2px solid #e0e0e0",
                    }}
                  >
                    <PersonIcon />
                  </Avatar>
                </Zoom>

                <LocationOn
                  sx={{ fontSize: 18, color: "#1976d2", mt: 0.3 }}
                />

                <Box sx={{ flex: 1 }}>
                  <Typography variant="body2" fontWeight="bold">
                    {punch.site_name}
                  </Typography>
                  <Typography variant="body2" fontWeight="bold">
                    Place: {punch.punch_place || "N/A"}
                  </Typography>

                  <Typography variant="caption" color="text.secondary">
                    Lat: {punch.latitude} | Long: {punch.longitude}
                  </Typography>
                </Box>
              </Stack>

              {/* Map Link */}
              {/* <Box sx={{ mt: 1, textAlign: "right" }}>
                <Typography
                  component="a"
                  href={`https://www.google.com/maps?q=${punch.latitude},${punch.longitude}`}
                  target="_blank"
                  sx={{
                    fontSize: "0.75rem",
                    color: "#1976d2",
                    textDecoration: "none",
                    fontWeight: "bold",
                    "&:hover": { textDecoration: "underline" },
                  }}
                >
                  VIEW ON MAP
                </Typography>
              </Box> */}
            </Card>
          ))}
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default AttendanceDetailDialog;
